import { ClipboardCheck } from 'lucide-react';
import React from 'react';

import { Switch } from '@/components/ui/catalyst/switch';
import {
  useGetCheckinConfigQuery,
  useUpdateCheckinConfigMutation,
} from '@/services/api/fridayCheckinService';

export const CheckinSettingsPage: React.FC = () => {
  const { data: config, isLoading } = useGetCheckinConfigQuery();
  const [updateConfig, { isLoading: isUpdating }] =
    useUpdateCheckinConfigMutation();

  const handleToggle = async () => {
    if (!config) return;
    await updateConfig({ is_enabled: !config.is_enabled });
  };

  return (
    <div className="mx-auto max-w-2xl px-6 py-10">
      <div className="mb-8">
        <h1 className="text-xl font-semibold text-zinc-900 dark:text-white">
          Check-In Settings
        </h1>
        <p className="mt-1 text-sm text-zinc-500 dark:text-zinc-400">
          Control the daily 3 PM ET check-in modal for all users.
        </p>
      </div>

      <div className="rounded-lg border border-zinc-200 dark:border-zinc-700 bg-white dark:bg-zinc-900 p-6">
        <div className="flex items-start justify-between gap-4">
          <div className="flex items-start gap-3">
            <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-violet-50 dark:bg-violet-950">
              <ClipboardCheck className="h-4 w-4 text-violet-600 dark:text-violet-400" />
            </div>
            <div>
              <h2 className="text-sm font-semibold text-zinc-900 dark:text-white">
                Daily Check-In Modal
              </h2>
              <p className="mt-0.5 text-xs text-zinc-500 dark:text-zinc-400">
                When enabled, all users see a &quot;Are you on track?&quot;
                modal every day at 3 PM Eastern. Turning this off prevents the
                modal from appearing for everyone.
              </p>
            </div>
          </div>
          <div className="shrink-0 pt-0.5">
            {isLoading ? (
              <div className="h-5 w-8 animate-pulse rounded-full bg-zinc-200 dark:bg-zinc-700" />
            ) : (
              <Switch
                checked={config?.is_enabled ?? false}
                onChange={handleToggle}
                disabled={isUpdating}
                color="violet"
              />
            )}
          </div>
        </div>

        {config && (
          <div className="mt-4 pt-4 border-t border-zinc-100 dark:border-zinc-800">
            <p className="text-xs text-zinc-500 dark:text-zinc-400">
              Status:{' '}
              <span
                className={
                  config.is_enabled
                    ? 'font-medium text-emerald-600 dark:text-emerald-400'
                    : 'font-medium text-zinc-400 dark:text-zinc-500'
                }
              >
                {config.is_enabled ? 'Enabled' : 'Disabled'}
              </span>
            </p>
          </div>
        )}
      </div>
    </div>
  );
};
